import React from 'react'
import PropTypes from 'prop-types'
import {LineChart, Line} from 'components/Chart'
import {getMetricByKey} from 'utils/metrics'
import dimensionsConfig from 'utils/dimensions'
import Label from 'components/Label'
import ChartTooltipList from 'components/ChartTooltipList'

const colors = [
  'awesome-blue',
  'brand-green',
  'brand-red',
  'brand-yellow',
  'grass',
  'pink',
  'yellow',
  'skyblue',
  'blue',
  'brand-gray'
]

export default class AnalyticsChart extends React.Component {
  static propTypes = {
    metric: PropTypes.string.isRequired,
    dimensions: PropTypes.array.isRequired,
    data: PropTypes.array,
    onLabelClick: PropTypes.func,
    onCloseClick: PropTypes.func,
    sites: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  }

  static contextTypes = {
    containerWidth: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedDate: null,
      selectedLine: null
    }
  }

  render() {
    const {containerWidth} = this.context
    if (!containerWidth) return null
    const {metric: metricKey, dimensions, data, onCloseClick} = this.props
    const {selectedDate, selectedLine} = this.state

    const {label: metricTitle, format: metricFormat} = getMetricByKey(metricKey)
    const margin = this.getChartMargins()

    return (
      <LineChart
        className='analytics-view_chart'
        width={containerWidth}
        height={250}
        data={data}
        format={metricFormat}
        min={0}
        xAxisKey='date'
        title={metricTitle}
        legend={this.renderLegend()}
        selected={selectedDate}
        onSelect={this.onSelect}
        tooltip={this.renderTooltip(metricFormat)}
        onClose={onCloseClick}
        margin={margin}
      >
        {dimensions.map((dimension, index) => (
          <Line
            key={index}
            dataKey={index}
            color={colors[index]}
            selected={selectedLine === index}
          />
        ))}
      </LineChart>
    )
  }

  renderLegend() {
    const {dimensions, onLabelClick} = this.props
    return dimensions.map((dimension, index) => {
      const onClick = onLabelClick ? () => onLabelClick(dimension) : null

      return (
        <Label
          key={index}
          color={colors[index]}
          onClick={onClick}
          tooltip={onClick && 'Hide this metric'}
        >
          {this.getDimensionLabel(dimension)}
        </Label>
      )
    })
  }

  renderTooltip = format => data => {
    const {dimensions} = this.props
    const values = dimensions.map((dimension, index) => {
      return {
        label: this.getDimensionLabel(dimension),
        color: colors[index],
        value: data[index]
      }
    }).sort((a, b) => a.value < b.value ? 1 : -1)

    return <ChartTooltipList items={values} date={data.date} format={format} />
  }

  onSelect = (date, dataKey) => {
    this.setState({selectedDate: date, selectedLine: dataKey})
  }

  getChartMargins() {
    const {data} = this.props
    const margin = {top: 30, right: 20, bottom: 40, left: 80}
    const allValues = data.reduce((acc, item) => (
      acc.concat(...Object.keys(item).reduce((a, b) => (b === 'date' ? a : a.concat(item[b])), []))
    ), [])
    const maxValue = Math.max(...allValues)
    if (maxValue > 99999 && maxValue < 999999) {
      margin.left = 85
    } else if (maxValue > 999999) {
      margin.left = 110
    }
    return margin
  }

  // dimensionPath is [{<dimensionId>: <dimensionValue>}, {<dimensionId>: <dimensionValue>} ...]
  getDimensionLabel(dimensionPath) {
    const {sites} = this.props
    if (dimensionPath.length === 0) return 'Total'
    dimensionPath = dimensionPath.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true
      }
      return false
    })
    return dimensionPath.map(dimension => {
      const [dimensionId] = Object.keys(dimension)

      const dimensionCf = dimensionsConfig
        .find(dimensionConfig => dimensionId === dimensionConfig.id)
      if (dimensionCf) {
        return dimensionCf.format(dimension[dimensionId], sites)
      }
      return null
    }).join(' / ')
  }
}



// WEBPACK FOOTER //
// ./client/views/AnalyticsView/AnalyticsChart.js